const IS_PRO = window.location.protocol.match("https");
const prefix = IS_PRO ? "https://" : "http://t";
export const ICT2B_CONFIG = {
  IS_PRO,
  BASE_URL: process.env.VUE_APP_SERVER,
  PRO_DOWNLOAD_URL: "https://ftpuedit.ictxuetang.com/",
  EMAIL_URL: `${
    IS_PRO ? `${prefix}email` : `${prefix}emailservice`
  }.ictxuetang.com/`,
  FTP_URL: `${prefix}ftpservice.ictxuetang.com/`
};
